import {
    QueryClient,
    useQuery,
    useMutation
  } from '@tanstack/react-query';
import { useContext } from 'react';
import { SnapshotContext } from './SnapshotContext';
  const apiURL = 'https://api.komin.transportkontent.pl';
  //const apiURL = 'http://127.0.0.1/kapi/GTFS/'; //musi kończyć się slashem
export const queryClient = new QueryClient()

// Ogólne

export function useSnapshots() {
  return useQuery({
    queryKey: ['snapshots'],
    queryFn: () =>
      fetch(apiURL).then((res) =>
        res.json(),
      ),
  }) 
}

// GTFS

export function useQueryGtfsResource(resourceTable) {
  const snap = useContext(SnapshotContext);
  return useQuery({
    queryKey: ['GTFS', snap, resourceTable],
    queryFn: () =>
      fetch(apiURL + snap.snap_prefix + '/' + resourceTable).then((res) => {
          return res.json()
        }
      ),
  }) 
}

export function useQueryGtfsResourceById(resourceTable, resourceId, additionalResourceId = null) {
  const snap = useContext(SnapshotContext);
  var resourceUrl = apiURL + snap.snap_prefix + '/' + resourceTable + '/' + encodeURIComponent(resourceId);
  if(additionalResourceId !== null) {
    resourceUrl = resourceUrl + '/' + encodeURIComponent(additionalResourceId);
  }
  console.log('res url',resourceUrl);

  return useQuery({
    queryKey: ['GTFS', snap, resourceTable, resourceId, additionalResourceId],
    queryFn: () =>
      fetch(resourceUrl).then((res) => {
          return res.json()
        }
      ),
  }) 
}

export function useDeleteGtfsResource(resourceTable) {
  const snap = useContext(SnapshotContext);

  return useMutation({
      mutationFn: (stopId) => 
      fetch(apiURL + snap.snap_prefix + '/'+ resourceTable +'/' + encodeURIComponent(stopId) + '/delete',{
        method: "GET",
        mode: 'cors',
        headers: {
          "Content-type": "text/plain"
        }        
      }).then( async res => {
        if(res.ok == false) {
          throw new Error(res.status + ' ' + res.statusText,{cause: body});
        }
      })
  })
}

export function useMutateGtfsResource() {
  const snap = useContext(SnapshotContext);
 
  return useMutation({
    mutationFn:  async (updatedItem) => {
      console.log('resourceTable in mutationFn:', updatedItem.query.resourceTable, typeof updatedItem.query.resourceTable);
      console.log('debug mutation: ', updatedItem);
      const res = await fetch(apiURL + snap.snap_prefix + '/' + updatedItem.query.resourceTable + '/' + encodeURIComponent(updatedItem.query.modified_id) + '/update', {
        method: "POST",
        body: JSON.stringify(
          updatedItem.fields
        ),
        mode: 'cors',
        headers: {
          "Content-type": "text/plain"
        }
      });
      const body = await res.json();
      if (res.ok == false) {
        throw new Error(res.status + ' ' + res.statusText, { cause: body });
      }
    },
     onMutate: async (updatedItem) => {
            console.log('resourceTable in onMutate:', updatedItem.query.resourceTable, typeof updatedItem.query.resourceTable);
            console.log('updatedItem',updatedItem);
            // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
            try {
              await queryClient.cancelQueries({ queryKey: ['GTFS', snap, updatedItem.query.resourceTable] });
            } catch (error) {
              console.error('Error in onMutate:', error);
            }            
            // Snapshot the previous value
            const previousData = queryClient.getQueryData(['GTFS', snap, updatedItem.query.resourceTable]);

            console.log('optimisticQueryKey',['GTFS', snap, updatedItem.query.resourceTable]);

            // Optimistically update to the new value
            try {
              queryClient.setQueryData(['GTFS', snap, updatedItem.query.resourceTable],(old) => {
                const newData = {...old};

                if (!newData[updatedItem.query.modified_id]) {
                  console.warn(`No entry for modified_id: ${updatedItem.query.modified_id}, creating one`);
                  newData[updatedItem.query.modified_id] = {}; // Tworzymy pusty obiekt dla tego ID
                }

                for (const [key, value] of Object.entries(updatedItem.fields)) {
                  newData[updatedItem.query.modified_id][key] = value;
                }
                return newData;
              }) 
            } catch (error) {
              console.error('Error in onMutate setQueryData:', error);
            }

            // Return a context object with the snapshotted value
            console.log('previousData:', previousData);
            return previousData || {}; // Zwróć pusty obiekt, jeśli `previousData` jest `undefined`
      },
      // If the mutation fails,
      // use the context returned from onMutate to roll back
      onError: (err, updatedItem, context) => {
        //queryClient.setQueryData(['GTFS', snap, updatedItem.query.resourceTable], context.previousData);
      },
        // Always refetch after error or success:
      onSettled: (data,error,variables,context) => {
        queryClient.invalidateQueries({queryKey: ['GTFS', snap, variables.query.resourceTable, variables.query.modified_id]});
        queryClient.invalidateQueries({queryKey: ['GTFS', snap, variables.query.resourceTable]});
        console.log('Invalidating query:', ['GTFS', snap, variables.query.resourceTable, variables.query.modified_id]);
      }, 
  });
}

export function useMutateBulkGtfsResource() {
  const snap = useContext(SnapshotContext);

  return useMutation({
    mutationFn: async (queryData) => {
        const res = await fetch(apiURL + snap.snap_prefix + '/' + queryData.query.resourceTable + '/bulk/' + queryData.query.action, {
          method: "POST",
          body: JSON.stringify(
            queryData.fields
          ),
          mode: 'cors',
          headers: {
            "Content-type": "text/plain"
          }
        })
        if (res.ok == false) {
          throw new Error(res.status + ' ' + res.statusText, { cause: body });
        }
    },
    onError: (error) => {
      // An error happened!
      console.log(`error:`, error, 'variables', variables, 'context', context)
    },
    onSuccess: (data, variables, context) => {
        console.log(`success data:`, data, 'variables', variables, 'context', context)
        console.log('Invalidating query:', ['GTFS', snap, variables.query.resourceTable]);
        queryClient.invalidateQueries({
          queryKey: ['GTFS', snap, variables.query.resourceTable]
        })
      }
  })

}

export function useNewGtfsResource(resourceTable) {
  const snap = useContext(SnapshotContext);

  return useMutation({
      mutationFn: (newItem) => 
      fetch(apiURL + snap.snap_prefix + '/'+resourceTable+'/new',{
        method: "POST",
        body: JSON.stringify(
          newItem.fields
        ),
        mode: 'cors',
        headers: {
          "Content-type": "text/plain"
        }        
      }).then( async res => {
        const body = await res.json();
        if(res.ok == false) {
          throw new Error(res.status + ' ' + res.statusText,{cause: body});
        }
      }),
      onSettled: () => {
        queryClient.invalidateQueries({queryKey: ['GTFS', snap, resourceTable]});
      }
  })
}

export function useGtfsSuggestNewId(resourceTable) {
  const snap = useContext(SnapshotContext);
  return useQuery({
    queryKey: [resourceTable, snap],
    queryFn: () =>
      fetch(apiURL + snap.snap_prefix + '/'+ resourceTable +'/newID').then((res) => {
          return res.json()
        }
      ),
  }) 
}

export function useQueryGtfsSegment(routeType,fromStopId,toStopId) {
  const snap = useContext(SnapshotContext);

  return useQuery({
    queryKey: ['GTFS', snap, 'segments', routeType, fromStopId, toStopId],
    queryFn: () =>
      fetch(apiURL + snap.snap_prefix + '/segments/' + routeType  + '/' + encodeURIComponent(fromStopId) + '/' + encodeURIComponent(toStopId)).then((res) => {
          return res.json()
        }
      ),
  }) 
}

export function useQueryGtfsSegmentShape(routeType,fromStopId,toStopId) {
  const snap = useContext(SnapshotContext);

  return useQuery({
    queryKey: ['GTFS', snap, 'segments', routeType, fromStopId, toStopId, 'shape'],
    queryFn: () =>
      fetch(apiURL + snap.snap_prefix + '/segments/' + routeType  + '/' + encodeURIComponent(fromStopId) + '/' + encodeURIComponent(toStopId) + '/shape').then((res) => {
          return res.json()
        }
      ),
  }) 
}

export function useMutateGtfsSegment() {
  const snap = useContext(SnapshotContext);

  return useMutation({
    mutationFn: async (queryData) => {
        const res = await fetch(apiURL + snap.snap_prefix + '/segments/' + queryData.query.route_type  + '/' + encodeURIComponent(queryData.query.from_stop_id) + '/' + encodeURIComponent(queryData.query.to_stop_id) + '/upsert', {
          method: "POST",
          body: JSON.stringify(
            queryData.fields
          ),
          mode: 'cors',
          headers: {
            "Content-type": "text/plain"
          }
        })
        if (res.ok == false) {
          throw new Error(res.status + ' ' + res.statusText, { cause: body });
        }
    } ,/*
    onError: (error) => {
      // An error happened!
      console.log(`error:`, error, 'variables', variables, 'context', context)
    },*/
    onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries({
          queryKey: ['GTFS', snap, 'segments']
        })
    } 
  })

}

// Deprakted:

export function useGTFS() {
  const snap = useContext(SnapshotContext);
  return useQuery({
    queryKey: ['stopsData', snap],
    queryFn: () =>
      fetch(apiURL + snap.snap_prefix + '/stops/').then((res) => {
          return res.json()
        }
      ),
  }) 
}

export function useGtfsRoutes() {
  const snap = useContext(SnapshotContext);
  return useQuery({
    queryKey: ['routesData', snap],
    queryFn: () =>
      fetch(apiURL + snap.snap_prefix + '/routes/').then((res) => {
          return res.json()
        }
      ),
  }) 
}

export function useGtfsStopById(id) {
  const snap = useContext(SnapshotContext);
  return useQuery({
    queryKey: ['stopsData', snap, id],
    queryFn: () =>
      fetch(apiURL + snap.snap_prefix + '/stops/' + encodeURIComponent(id)).then((res) => {
          return res.json()
        }
      ),
  }) 
}



export function useMutateGtfsStop() {
  const snap = useContext(SnapshotContext);
 
  return useMutation({
    mutationFn: (updatedItem) => 
      fetch(apiURL + snap.snap_prefix + '/stops/' + encodeURIComponent(updatedItem.query.modified_stop_id) + '/update', {
        method: "POST",
        body: JSON.stringify(
          updatedItem.fields
        ),
        mode: 'cors',
        headers: {
          "Content-type": "text/plain"
        }        
      }).then( async res => {
        const body = await res.json();
        if(res.ok == false) {
          throw new Error(res.status + ' ' + res.statusText,{cause: body});
        }
      }),
      onMutate: async (updatedItem) => {
            console.log('OnMutate',updatedItem);
            // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
            await queryClient.cancelQueries({ queryKey: ['GTFS', snap, 'stops'] });
            
            // Snapshot the previous value
            const previousStops = queryClient.getQueryData(['GTFS', snap, 'stops']);

            // Optimistically update to the new value
             queryClient.setQueryData(['GTFS', snap, 'stops'],(old) => {
              const newData = {...old};
              for (const [key, value] of Object.entries(updatedItem.fields)) {
                newData[updatedItem.query.modified_stop_id][key] = value;
              }
              return newData;
            }) 

            // Return a context object with the snapshotted value
            return previousStops; 
      },
      // If the mutation fails,
      // use the context returned from onMutate to roll back
      onError: (err, updatedItem, context) => {
        queryClient.setQueryData(['GTFS', snap, 'stops'], context.previousStops);
      },
        // Always refetch after error or success:
      onSettled: (data,error,variables,context) => {
        console.log('settled:',data,error,variables,context)
        console.log('inwalidacja',['GTFS', snap, 'stops', variables.query.modified_stop_id]);
        queryClient.invalidateQueries({queryKey: ['GTFS', snap, 'stops', variables.query.modified_stop_id]});
        queryClient.invalidateQueries({queryKey: ['GTFS', snap, 'stops']});

        queryClient.invalidateQueries({queryKey: ['stopsData']});
        queryClient.invalidateQueries({queryKey: ['stops', snap]});
      },
  });
}

export function useNewGtfsStop() {
  const snap = useContext(SnapshotContext);

  return useMutation({
      mutationFn: (newItem) => 
      fetch(apiURL + snap.snap_prefix + '/stops/new',{
        method: "POST",
        body: JSON.stringify(
          newItem.fields
        ),
        mode: 'cors',
        headers: {
          "Content-type": "text/plain"
        }        
      }).then( async res => {
        const body = await res.json();
        if(res.ok == false) {
          throw new Error(res.status + ' ' + res.statusText,{cause: body});
        }
      }),
      onSettled: () => {
        queryClient.invalidateQueries({queryKey: ['stopsData']});
        queryClient.invalidateQueries({queryKey: ['stops', snap]});
      }
  })
}

export function useDeleteGtfsStop() {
  const snap = useContext(SnapshotContext);

  return useMutation({
      mutationFn: (stopId) => 
      fetch(apiURL + snap.snap_prefix + '/stops/' + encodeURIComponent(stopId) + '/delete',{
        method: "GET",
        mode: 'cors',
        headers: {
          "Content-type": "text/plain"
        }        
      }).then( async res => {
        if(res.ok == false) {
          throw new Error(res.status + ' ' + res.statusText,{cause: body});
        }
      })
  })
}

export function useNewGtfsRoute() {
  const snap = useContext(SnapshotContext);

  return useMutation({
      mutationFn: (newItem) => 
      fetch(apiURL + snap.snap_prefix + '/routes/new',{
        method: "POST",
        body: JSON.stringify(
          newItem.fields
        ),
        mode: 'cors',
        headers: {
          "Content-type": "text/plain"
        }        
      }).then( async res => {
        const body = await res.json();
        if(res.ok == false) {
          throw new Error(res.status + ' ' + res.statusText,{cause: body});
        }
      }),
      onSettled: () => {
        queryClient.invalidateQueries({queryKey: ['GTFS', snap, 'routes']});
      }
  })
}

/* export function useMutateGtfsStop() {
  const snap = useContext(SnapshotContext);
 
  return useMutation({
    mutationFn: (updatedItem) => 
      fetch(apiURL + snap.snap_prefix + '/stops/' + updatedItem.query.modified_stop_id + '/update', {
        method: "POST",
        body: JSON.stringify(
          updatedItem.fields
        ),
        mode: 'cors',
        headers: {
          "Content-type": "text/plain"
        }        
      }).then( res => {
        if (res.ok) {
          queryClient.invalidateQueries({queryKey: ['stopsData']})
        } else {
          throw new Error(`Http error: ${res.status}`);
        }
      })
  });
} */